import { render, staticRenderFns } from "./ekportal.vue?vue&type=template&id=553d303f&"
import script from "./ekportal.vue?vue&type=script&lang=js&"
export * from "./ekportal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports